/* eslint-disable react/prop-types */
import React, { Component, lazy } from 'react';
import { observer } from 'mobx-react';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import PropTypes from 'prop-types';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IFrame } from '@src/slide/domain/ui-model/element-modeles/property/frame/frame.interface';

const CanvasElementPc = lazy(() => import(/* webpackChunkName: "lazyComponents" */ './canvas-element-pc'));
const CanvasElementMobile = lazy(() => import(/* webpackChunkName: "lazyComponentsMobile" */ './canvas-element-mobile'));

export const CanvasElementPropTypes = {
    onResize: PropTypes.func,
    onResizeStart: PropTypes.func,
    onResizeStop: PropTypes.func,
    onRotate: PropTypes.func,
    onRotateStart: PropTypes.func,
    onRotateStop: PropTypes.func,
    onBorderMouseDown: PropTypes.func,
    onBorderDoubleClick: PropTypes.func,
    onBorderMouseUp: PropTypes.func,
    draggable: PropTypes.bool,
    resizeHorizontal: PropTypes.bool,
    resizeVertical: PropTypes.bool,
    canRotate: PropTypes.bool,
    showSelectBorder: PropTypes.bool,
    borderDraggable: PropTypes.bool,
    scale: PropTypes.number,
    rotate: PropTypes.number,
    originX: PropTypes.number,
    originY: PropTypes.number,
    isDragging: PropTypes.bool,
    isSelected: PropTypes.bool,
    isResizing: PropTypes.bool,
    isRotating: PropTypes.bool,
    isCroping: PropTypes.bool,
    isMobileRotatingMode: PropTypes.bool,
    setIsMobileRotatingMode: PropTypes.func,
    selectedElementInGroupInMobile: PropTypes.bool,
    isPreview: PropTypes.bool,
    isPlaceholder: PropTypes.bool,
    editable: PropTypes.bool,
    getSize: PropTypes.func,
    rect: PropTypes.object,
    children: PropTypes.node,
    component: PropTypes.shape({
        props: PropTypes.object,
    }),
    style: PropTypes.object,
    relativeRotate: PropTypes.number,
    relativeFlipH: PropTypes.number,
    relativeFlipV: PropTypes.number,
    fromScale: PropTypes.number,
};

export interface CanvasElementPropType {
    onDrag?: (...arg: any[]) => any;
    onDragStart?: (...arg: any[]) => any;
    onDragStop?: (...arg: any[]) => any;
    onResize?: (...arg: any[]) => any;
    onResizeStart?: (...arg: any[]) => any;
    onResizeStop?: (...arg: any[]) => any;
    onRotate?: (...arg: any[]) => any;
    onRotateStart?: (...arg: any[]) => any;
    onRotateStop?: (...arg: any[]) => any;
    onBorderMouseDown?: (...arg: any[]) => any;
    onBorderDoubleClick?: (...arg: any[]) => any;
    onBorderMouseUp?: (...arg: any[]) => any;
    onBorderClick?: (...arg: any[]) => any;
    draggable?: boolean;
    resizeHorizontal?: boolean;
    resizeVertical?: boolean;
    canRotate?: boolean;
    showSelectBorder?: boolean;
    borderDraggable?: boolean;
    scale: number;
    rotate?: number;
    originX?: number;
    originY?: number;
    isDragging?: boolean;
    isSelected?: boolean;
    isResizing?: boolean;
    isRotating?: boolean;
    isCroping?: boolean;
    isMobileRotatingMode?: boolean;
    setIsMobileRotatingMode?: (...arg: any[]) => any;
    selectedElementInGroupInMobile?: boolean;
    isPreview?: boolean;
    isPlaceholder?: boolean;
    editable?: boolean;
    getSize: (...arg: any[]) => any;
    rect: IFrame;
    children?: React.ReactNode;
    component: IElementBaseModel;
    style: object;
    relativeRotate?: number;
    relativeFlipH?: number;
    relativeFlipV?: number;
    fromScale?: number;
}

@observer
class CanvasElement extends Component<CanvasElementPropType> {
    public render() {
        return (
            <React.Fragment>
                {
                    browser.isMobile
                        ? <CanvasElementMobile { ...this.props } />
                        : <CanvasElementPc  { ...this.props }  />
                }
            </React.Fragment>
        );
    }
}

export default CanvasElement;
